export const getCurrentSeasonStartYear = (
  date = new Date()
) => {
  const year = date.getFullYear();
  const month = date.getMonth();

  // Août = index 7
  return month >= 7 ? year : year - 1;
};

export const formatSeason = (startYear) =>
  `${startYear}-${startYear + 1}`;

export const parseSeasonStartYear = (season) => {
  const startYear = Number.parseInt(
    String(season || "").split("-")[0],
    10
  );

  return Number.isFinite(startYear)
    ? startYear
    : getCurrentSeasonStartYear();
};

export const getCurrentSeason = () =>
  formatSeason(getCurrentSeasonStartYear());

export const getSeasonOptions = ({
  previous = 2,
  next = 2,
} = {}) => {
  const currentStartYear = getCurrentSeasonStartYear();

  return Array.from(
    {
      length: previous + next + 1,
    },
    (_, index) =>
      formatSeason(
        currentStartYear - previous + index
      )
  );
};

export const isCurrentSeason = (season) =>
  season === getCurrentSeason();